// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"2828426a","36":"d3f9f210","222":"69cb82ba","231":"6e7b9652","318":"a7d6bd8e","371":"d85e5244","423":"40b52fe2","453":"ff8d5704","465":"462d9082","569":"97c041c9"}[chunkId] + ".chunk.js";
};